import React from "react";
import "./Possubscription.css";

const plans = [
  {
    name: "BASIC",
    price: "₹999 / MONTH",
    modules: ["HOME (READ ONLY)", "PROFILE", "DIRECTORY"],
  },
  {
    name: "STANDARD",
    price: "₹1999 / MONTH",
    popular: true,
    modules: [
      "HOME",
      "COMPANY",
      "DIRECTORY",
      "PROFILE",
      "PROFESSIONAL",
      "ATTENDANCE",
      "TICKETING",
    ],
  },
  {
    name: "PREMIUM",
    price: "₹3999 / MONTH",
    modules: [
      "HOME",
      "COMPANY",
      "DIRECTORY",
      "PROFILE",
      "PROFESSIONAL",
      "ATTENDANCE",
      "PAYROLL",
      "TICKETING",
      "ASSETS",
      "REPORTS",
    ],
  },
];

const PosSubscriptionPremium = () => {
  return (
    <div className="pos-premium-wrapper">
      <h1 className="pos-premium-title">POS BILLING  <span style={{color:"#7564e6"}}>MANAGEMENT</span></h1>
      <p className="pos-premium-subtitle">
        Powerful plans designed for growing businesses
      </p>

      <div className="pos-premium-grid">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`pos-premium-card ${
              plan.popular ? "pos-premium-highlight" : ""
            }`}
          >
            {plan.popular && (
              <span className="pos-premium-badge">MOST POPULAR</span>
            )}

            <h2 className="pos-premium-plan-name">{plan.name}</h2>
            <h3 className="pos-premium-price">{plan.price}</h3>

            {/* MODULE SECTION WITH FIXED HEIGHT */}
            <div className="pos-premium-modules">
              <p className="pos-premium-module-title">MODULE ACCESS</p>
              <ul>
                {Array.from({ length: 10 }).map((_, i) => (
                  <li key={i}>
                    {plan.modules[i] ? `✔ ${plan.modules[i]}` : " "}
                  </li>
                ))}
              </ul>
            </div>

            {/* BUTTON ALWAYS AT BOTTOM */}
            <button className="pos-premium-btn">
              ACTIVATE {plan.name}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PosSubscriptionPremium;

